/**
 * Tradução dos códigos do Mercado Pago e do Mercado Livre para português.
 *
 * POR QUE EXISTE: a lista mostrava os códigos crus da API — `approved`,
 * `cancelled`, `credit_card`. Quem opera a página é o financeiro e o fiscal, não
 * quem integra a API, e ler código de sistema exige uma tradução mental a cada
 * linha.
 *
 * REGRA DE OURO: código desconhecido é DEVOLVIDO COMO VEIO, nunca escondido. Se
 * o Mercado Pago criar um status novo amanhã, é melhor a tela mostrar
 * `in_process` do que uma célula vazia ou um "—" que finge que não há dado.
 *
 * Os valores abaixo foram levantados do banco (contagens de 06/08/2026), não
 * inventados a partir da documentação:
 *   payments.status         approved 147.064 · refunded 8.212 · rejected 2.985 ·
 *                           cancelled 1.088 · in_mediation 341 · charged_back 199
 *   payments.payment_type_id credit_card 63.171 · account_money 50.249 ·
 *                           bank_transfer 40.250 · digital_currency 5.759 ·
 *                           ticket 353 · prepaid_card 107
 *   sales.status            paid 582.513 · cancelled 34.840 ·
 *                           partially_refunded 952 · pending_cancel 3
 */

/** Situação do PAGAMENTO no Mercado Pago. */
export const PAYMENT_STATUS_PT = {
    approved: 'Aprovado',
    refunded: 'Estornado',
    rejected: 'Recusado',
    cancelled: 'Cancelado',
    in_mediation: 'Em mediação',
    charged_back: 'Chargeback',
    // Não apareceram na base, mas existem no vocabulário do MP — melhor prever
    // que deixar o operador diante de um código solto no dia em que surgirem.
    pending: 'Pendente',
    authorized: 'Autorizado',
    in_process: 'Em análise',
};

/** Situação do PEDIDO no Mercado Livre. */
export const ORDER_STATUS_PT = {
    paid: 'Pago',
    cancelled: 'Cancelado',
    partially_refunded: 'Estornado em parte',
    pending_cancel: 'Cancelamento em curso',
    confirmed: 'Confirmado',
    payment_required: 'Aguardando pagamento',
    payment_in_process: 'Pagamento em análise',
    partially_paid: 'Pago em parte',
    invalid: 'Inválido',
};

/**
 * Meio de pagamento. Encurtado de propósito: a coluna é estreita e "Cartão de
 * crédito" já diz o que "credit_card" dizia.
 */
export const PAYMENT_TYPE_PT = {
    credit_card: 'Cartão de crédito',
    debit_card: 'Cartão de débito',
    account_money: 'Saldo em conta',
    bank_transfer: 'Pix / transferência',
    digital_currency: 'Moeda digital',
    ticket: 'Boleto',
    prepaid_card: 'Cartão pré-pago',
    digital_wallet: 'Carteira digital',
    voucher_card: 'Vale',
    atm: 'Caixa eletrônico',
};

/** Detalhe do status (o `accredited` que vinha grudado no status na mesma célula). */
export const STATUS_DETAIL_PT = {
    accredited: 'creditado',
    pending_contingency: 'em contingência',
    pending_review_manual: 'em revisão manual',
    cc_rejected_insufficient_amount: 'saldo insuficiente',
    cc_rejected_bad_filled_security_code: 'código de segurança inválido',
    cc_rejected_bad_filled_date: 'validade inválida',
    cc_rejected_high_risk: 'recusado por risco',
    cc_rejected_call_for_authorize: 'exige autorização do banco',
    refunded: 'estornado',
    by_payer: 'pelo pagador',
    by_collector: 'pelo vendedor',
    expired: 'expirado',
};

/**
 * Traduz preservando o desconhecido. `null`/vazio devolve `null` para a UI
 * decidir o traço — não é papel do dicionário inventar placeholder.
 */
export function Traduzir(dicionario, codigo) {
    const chave = String(codigo || '').trim();
    if (!chave) {
        return null;
    }
    return dicionario[chave] || chave;
}
